import { useEffect, useState } from 'react';
import { Article } from './types';
import ArticleContent from './ArticleContent';

export default function ArticleCard({ article }: { article: Article; }) {

    const [displayFully, setDisplayFully] = useState<boolean>(false);

    useEffect(() => {
        setDisplayFully(false);
    }, [article]);

    return (<>
        <div className="relative text-gray-800">
            <div className={!displayFully ? 'max-h-64 overflow-hidden' : ''}>
                <ArticleContent article={article} />
                {!displayFully && (
                    <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white  to-transparent pointer-events-none" />
                )}
            </div>
        </div>
        {
            !displayFully && (
                <div className="flex justify-center mt-4">
                    <button
                        onClick={() => setDisplayFully(true)}
                        className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
                    >
                        Lire en entier
                    </button>
                </div>
            )
        }
    </>
    );
}